<template>
  <div id="splash-screen">
  </div>
</template>
<script>
import { apiUrl } from "../vars";
import { siteUrl } from "../vars";
import auth from "../auth";

export default {
  created() {
    let signout = this.$route.query.signout;
    if (signout) {
      auth.signout(this);
    }
  },
  methods: {}
};
</script>
<style scoped lang="scss">
#-splash-screen {
  background-color: #2d3256;
  min-width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/Incoming.vue